import { Routes } from '@angular/router';

/**
 * El tablero de inicio no lleva `permisoGuard`: la sesión que exige el
 * `authGuard` del armazón es todo lo que necesita. Es la pantalla de aterrizaje
 * de cualquier usuario autenticado.
 */
export const inicioRoutes: Routes = [
  {
    path: 'inicio',
    loadComponent: () => import('./pages/inicio/inicio.page').then((m) => m.InicioPage),
    title: 'SiLabVet | Inicio',
  },
];
